import {Injectable, Pipe, PipeTransform} from '@angular/core';

/**
 This is a very limited formatter that assumes US/Canadian phone numbers -- if there are more than ten digits (after ignoring non-numeric characters), it
 formats the last 10 characters (ignores +1 or other international codes).  If it was passed an empty string, it returns the input unchanged.
 */
@Injectable({providedIn: 'root'})
@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {
  transform(value?: string | null): string {
    const rawValue: string = value?.replace(/\D/g, '') ?? ''; // Remove all non-digit characters.

    return rawValue.length
      ? rawValue.slice(-10).replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
      : (value ?? '');
  }
}
